// extracted by mini-css-extract-plugin
export default {"headerContainer":"textPages_headerContainer__1guZP","content":"textPages_content__o1YP5","mainContainer":"textPages_mainContainer__gzxnW","sidebar":"textPages_sidebar__pnJ55"};